module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Division\n        ")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canCreateDivision()),
      expression: "canCreateDivision()"
    }],
    attrs: {
      "slot": "extra",
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.modal.createDivision = true
      }
    },
    slot: "extra"
  }, [_vm._v("\n                Tambah\n            ")]), _vm._v(" "), [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columnTableDivision,
      "data": _vm.divisions
    }
  })]], 2), _vm._v(" "), [_c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.modal.createDivision),
      callback: function($$v) {
        _vm.$set(_vm.modal, "createDivision", $$v)
      },
      expression: "modal.createDivision"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Division")])], 1), _vm._v(" "), _c('Form', {
    ref: "formDivision",
    attrs: {
      "model": _vm.formDivision,
      "rules": _vm.ruleValidate
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Division Name",
      "prop": "divisionName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Division Name"
    },
    model: {
      value: (_vm.formDivision.divisionName),
      callback: function($$v) {
        _vm.$set(_vm.formDivision, "divisionName", $$v)
      },
      expression: "formDivision.divisionName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingCreateDivision
    },
    on: {
      "click": _vm.postCreateDivision
    }
  }, [(!_vm.loadingCreateDivision) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1)], _vm._v(" "), [_c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.modal.editDivision),
      callback: function($$v) {
        _vm.$set(_vm.modal, "editDivision", $$v)
      },
      expression: "modal.editDivision"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Edit Division")])], 1), _vm._v(" "), _c('Form', {
    ref: "formEditDivision",
    attrs: {
      "model": _vm.formEditDivision,
      "rules": _vm.ruleValidate
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Division Name",
      "prop": "divisionName"
    }
  }, [_c('Input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "placeholder": "Id Division Name"
    },
    model: {
      value: (_vm.formEditDivision.id),
      callback: function($$v) {
        _vm.$set(_vm.formEditDivision, "id", $$v)
      },
      expression: "formEditDivision.id"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Division Name"
    },
    model: {
      value: (_vm.formEditDivision.divisionName),
      callback: function($$v) {
        _vm.$set(_vm.formEditDivision, "divisionName", $$v)
      },
      expression: "formEditDivision.divisionName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingEditDivision
    },
    on: {
      "click": _vm.postEditDivision
    }
  }, [(!_vm.loadingEditDivision) ? _c('span', [_vm._v("Edit")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc0f136","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/master/Division.vue
// module id = 1838
// module chunks = 1